const TAB_ID = 'tab_' + Math.random().toString(36).substring(2, 9) + '_' + Date.now();

let channel: BroadcastChannel | null = null;
if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
  try {
    channel = new BroadcastChannel('edgar_cayce_tts_channel');
  } catch (e) {
    console.warn('BroadcastChannel unsupported or unavailable', e);
  }
}

/**
 * Notify all other open tabs that speech synthesis has started in this tab.
 */
export function notifyTTSStarted(): void {
  if (channel) {
    try {
      channel.postMessage({ type: 'START_TTS', tabId: TAB_ID });
    } catch (e) {
      console.warn('Failed to post TTS broadcast message', e);
    }
  }
}

/**
 * Subscribe to notifications from other tabs when they start speech synthesis.
 * Calls `onOtherTabTTS` whenever speech starts in another tab so this tab can stop its active TTS.
 */
export function subscribeOtherTabTTS(onOtherTabTTS: () => void): () => void {
  if (!channel) return () => {};

  const handleMessage = (event: MessageEvent) => {
    if (event.data?.type === 'START_TTS' && event.data?.tabId !== TAB_ID) {
      onOtherTabTTS();
    }
  };

  channel.addEventListener('message', handleMessage);
  return () => {
    if (channel) {
      channel.removeEventListener('message', handleMessage);
    }
  };
}
